export enum DealStatus {
    NEW = 'new',
    TRANSFER_WAITING = 'transfer_waiting',
    TRANSFER_CONFIRMED = 'transfer_confirmed',
    COMPLETED = 'completed',
    CANCELED = 'canceled',
    DISPUTE = 'dispute',
}